import Vue from 'vue'
import VueTheMask from './v-mask'
Vue.use(VueTheMask)
